export enum ModalSizes {
	sm = "sm",
	md = "md",
	lg = "lg",
	custom = "custom"
}
